import React, { useMemo } from 'react';
import { FormCustomField } from '@eas/common-web';
import { Wgs84Coordinates } from '../../models';
import { MarkerLayer } from '../../components/map/marker-layer';
import { Marker } from '../../components/map/marker';
import { Line } from '../../components/map/line';
import { MarkerType } from '../../components/map/map-types';
import { MapContainer } from '../../components/map/map-container';

export function CompareLocation({
  newLocation,
  originalLocation,
}: {
  originalLocation?: Wgs84Coordinates;
  newLocation?: Wgs84Coordinates;
}) {
  const defaultMapPosition = useMemo(() => {
    if (newLocation && originalLocation) {
      return [newLocation, originalLocation];
    }
    if (newLocation) {
      return newLocation;
    }
    return undefined;
  }, [newLocation, originalLocation]);

  const isChanged = useMemo(() => {
    return (
      newLocation?.lat !== originalLocation?.lat ||
      newLocation?.lon !== originalLocation?.lon
    );
  }, [newLocation, originalLocation]);

  if (!isChanged) {
    return null;
  } else {
    return (
      <FormCustomField label="Poloha">
        <MapContainer height={550} defaultWgs84Position={defaultMapPosition}>
          <MarkerLayer>
            <Line from={newLocation} to={originalLocation} />
            <Marker
              type={MarkerType.BIG_GREY}
              innerTitle="Původ."
              lat={originalLocation?.lat ?? 0}
              lon={originalLocation?.lon ?? 0}
            />

            <Marker
              type={MarkerType.BIG_RED}
              innerTitle="Nové"
              lat={newLocation?.lat ?? 0}
              lon={newLocation?.lon ?? 0}
            />
          </MarkerLayer>
        </MapContainer>
      </FormCustomField>
    );
  }
}
